import React, { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import AdminLayout from '../../components/AdminLayout';
import StatCards from '../../components/StatCards';
import {
  getAllTopPicks,
  addTopPick,
  updateTopPick,
  deleteTopPick,
  getAllProductsUnpaginated,
  IMAGE_BASE_URL,
} from '../../services/api';

var e = React.createElement;

var buildImageUrl = function (path) {
  if (!path) return '';
  if (/^(https?:|blob:|data:)/i.test(path)) return path;
  var base = (IMAGE_BASE_URL || '').replace(/\/+$/, '');
  var p = path.replace(/^\/+/, '');
  return base ? base + '/' + p : '/' + p;
};

var isActiveStatus = function (item) {
  return String((item && item.status) || 'active').toLowerCase() === 'active';
};

var getProductImage = function (product) {
  if (!product) return '';
  var img = (product.images && product.images[0]) || product.image || '';
  return buildImageUrl(typeof img === 'string' ? img : '');
};

// ── Icons ──
var EyeIcon = function () {
  return React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' }),
    React.createElement('circle', { cx: 12, cy: 12, r: 3 })
  );
};
var PencilIcon = function () {
  return React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('path', { d: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' }),
    React.createElement('path', { d: 'M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z' })
  );
};
var TrashIcon = function () {
  return React.createElement('svg', { width: 14, height: 14, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('polyline', { points: '3 6 5 6 21 6' }),
    React.createElement('path', { d: 'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' }),
    React.createElement('path', { d: 'M10 11v6M14 11v6' }),
    React.createElement('path', { d: 'M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2' })
  );
};
var XIcon = function () {
  return React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2.5, strokeLinecap: 'round', strokeLinejoin: 'round' },
    React.createElement('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
    React.createElement('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
  );
};

// ── Portaled Dropdown ──
var PortaledDropdown = function (props) {
  React.useEffect(function () {
    var handler = function (ev) {
      if (!ev.target.closest('.act-menu-dd-portal')) props.onClose();
    };
    document.addEventListener('mousedown', handler);
    return function () { document.removeEventListener('mousedown', handler); };
  }, [props.onClose]);

  return createPortal(
    React.createElement('div', {
      className: 'act-menu-dd-portal',
      style: { position: 'fixed', top: props.top, right: props.right, minWidth: 162, background: '#ffffff', border: '1px solid rgba(62,124,140,0.22)', borderRadius: 12, boxShadow: '0 16px 40px rgba(109,40,217,0.2)', padding: 6, zIndex: 999999 }
    },
      React.createElement('button', {
        type: 'button', onClick: function () { props.onClose(); props.onView(); },
        style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#C4B5FD', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', textAlign: 'left' }
      }, React.createElement('span', { style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#A855F7' } }, React.createElement(EyeIcon, null)), 'View'),
      React.createElement('button', {
        type: 'button', onClick: function () { props.onClose(); props.onEdit(); },
        style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#C4B5FD', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', textAlign: 'left' }
      }, React.createElement('span', { style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#A855F7' } }, React.createElement(PencilIcon, null)), 'Edit'),
      React.createElement('button', {
        type: 'button', onClick: function () { props.onClose(); props.onDelete(); },
        style: { width: '100%', display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px', border: 'none', background: 'transparent', color: '#b91c1c', fontSize: 13, fontWeight: 600, borderRadius: 8, cursor: 'pointer', textAlign: 'left' }
      }, React.createElement('span', { style: { width: 18, height: 18, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#b91c1c' } }, React.createElement(TrashIcon, null)), 'Remove')
    ),
    document.body
  );
};

// ── Delete Confirm Modal (same style as Categories) ──
var DeleteConfirmModal = function (props) {
  return React.createElement('div', {
    style: { position: 'fixed', inset: 0, background: 'rgba(254,229,242,.92)', backdropFilter: 'blur(8px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 },
    onClick: function (ev) { if (ev.target === ev.currentTarget && !props.deleting) props.onCancel(); }
  },
    React.createElement('div', {
      style: { width: 'min(520px, 90vw)', borderRadius: 24, background: 'linear-gradient(180deg,#fff8ed,#fff4e6)', border: '1px solid rgba(251,191,36,.18)', boxShadow: '0 40px 80px rgba(249,115,22,.22)', padding: '32px', textAlign: 'center', color: '#1f1238' }
    },
      React.createElement('div', { style: { width: 60, height: 60, borderRadius: '50%', margin: '0 auto 20px', background: 'rgba(251,191,36,.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, fontWeight: 800, color: '#c2410c' } }, '!'),
      React.createElement('h2', { style: { color: '#c2410c', fontSize: 26, fontWeight: 800, margin: '0 0 8px' } }, 'Confirm remove?'),
      React.createElement('p', { style: { color: '#7c4a1f', fontSize: 15, margin: '0 0 20px', fontWeight: 500 } }, 'This will remove the product from the Top Picks section. The product itself will not be deleted.'),
      React.createElement('div', { style: { display: 'flex', width: 'fit-content', margin: '0 auto 24px', padding: '12px 22px', borderRadius: 999, border: '1px solid rgba(251,191,36,0.4)', background: 'rgba(255,248,233,0.9)', color: '#92400e', fontWeight: 800, fontSize: 15, justifyContent: 'center' } }, props.productName || 'selected item'),
      React.createElement('div', { style: { display: 'flex', justifyContent: 'center', gap: 14 } },
        React.createElement('button', { onClick: props.onCancel, disabled: props.deleting, style: { padding: '12px 22px', borderRadius: 14, border: '1px solid rgba(56,139,253,0.35)', background: 'rgba(235,248,255,0.95)', color: '#0c4a6e', fontWeight: 800, cursor: 'pointer' } }, 'Cancel'),
        React.createElement('button', { onClick: props.onConfirm, disabled: props.deleting, style: { padding: '12px 22px', borderRadius: 14, border: 'none', background: '#f97316', color: '#fff', fontWeight: 800, cursor: 'pointer', opacity: props.deleting ? 0.6 : 1 } }, props.deleting ? 'Removing…' : 'Remove')
      )
    )
  );
};

var css = [
  "@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');",
  ".tp-page{padding:20px;width:100%;box-sizing:border-box;font-family:'Outfit',sans-serif;color:#0F172A;}",
  ".tp-header-row{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;margin-bottom:20px;}",
  ".tp-header-main{display:flex;align-items:center;gap:10px;}",
  ".tp-header-icon{display:inline-flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:14px;background:#FFF7E8;color:#D99A2B;box-shadow:inset 0 0 0 1px rgba(217,154,43,0.16);}",
  ".tp-heading{margin:0;font-size:20px;font-weight:800;color:#0F172A;}",
  ".tp-subtitle{margin:4px 0 0;color:#8B5CF6;font-size:12px;font-weight:700;}",
  ".tp-new-btn{display:inline-flex;align-items:center;gap:6px;border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;border-radius:999px;padding:9px 18px;font-size:13px;font-weight:800;font-family:'Outfit',sans-serif;cursor:pointer;box-shadow:0 6px 18px rgba(109,40,217,0.3);transition:transform .15s;white-space:nowrap;}",
  ".tp-new-btn:hover{transform:translateY(-2px);}",

  /* inline Add form */
  ".tp-form-wrap{overflow:hidden;max-height:0;transition:max-height 0.5s ease;margin-bottom:0;}",
  ".tp-form-wrap.open{max-height:600px;margin-bottom:20px;}",
  ".tp-form-box{background:#20105E;border:1px solid #312E81;border-radius:18px;padding:22px;}",
  ".tp-form-top{display:flex;align-items:center;justify-content:space-between;margin-bottom:18px;}",
  ".tp-form-title{margin:0;font-size:16px;font-weight:800;color:#FFFFFF;}",
  ".tp-form-close{border:none;background:rgba(109,40,217,0.15);color:#A855F7;padding:7px 13px;border-radius:9px;font-size:12px;font-weight:700;cursor:pointer;font-family:'Outfit',sans-serif;}",
  ".tp-group{display:grid;gap:14px;}",
  ".tp-field-row{display:grid;grid-template-columns:1fr 1fr;gap:14px;}",
  "@media(max-width:540px){.tp-field-row{grid-template-columns:1fr;}}",
  ".tp-label{display:block;margin-bottom:5px;color:#C4B5FD;font-size:11px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;}",
  ".tp-select,.tp-input{width:100%;border:1px solid #312E81;border-radius:11px;padding:10px 12px;background:rgba(32,16,94,0.6);color:#FFFFFF;font-family:'Outfit',sans-serif;font-size:13px;outline:none;transition:border-color .14s;box-sizing:border-box;}",
  ".tp-select:focus,.tp-input:focus{border-color:#6D28D9;box-shadow:0 0 0 3px rgba(109,40,217,0.2);}",
  ".tp-select option{background:#20105E;color:#FFFFFF;}",
  ".cs-dropdown-list{max-height:220px;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none;}",
  ".cs-dropdown-list::-webkit-scrollbar{display:none;}",
  ".tp-cs-trigger{width:100%;text-align:left;cursor:pointer;padding:10px 12px;border-radius:11px;border:1px solid rgba(62,124,140,0.28);background:#FFFFFF;color:#102a33;font-family:'Outfit',sans-serif;font-size:13px;font-weight:700;display:flex;justify-content:space-between;align-items:center;box-sizing:border-box;box-shadow:0 1px 2px rgba(15,23,42,0.04);}",
  ".tp-cs-trigger:hover{border-color:#3E7C8C;box-shadow:0 0 0 3px rgba(62,124,140,0.14);}",
  ".tp-submit-row{display:flex;gap:10px;flex-wrap:wrap;margin:20px -26px -26px;padding:14px 26px 0;background:#20105E;border-top:1px solid rgba(49,46,129,.75);position:sticky;bottom:-26px;z-index:2;}",
  ".tp-submit{border:none;background:linear-gradient(135deg,#6D28D9,#A855F7);color:#fff;font-size:13px;font-weight:800;padding:10px 18px;border-radius:11px;cursor:pointer;font-family:'Outfit',sans-serif;transition:transform .14s;}",
  ".tp-submit:hover:not(:disabled){transform:translateY(-1px);}",
  ".tp-submit:disabled{opacity:0.6;cursor:not-allowed;}",
  ".tp-reset{border:1px solid #312E81;background:transparent;color:#A855F7;font-size:13px;font-weight:700;padding:10px 18px;border-radius:11px;cursor:pointer;font-family:'Outfit',sans-serif;}",
  ".tp-msg{margin-top:4px;font-weight:700;font-size:13px;}",
  ".tp-global-msg{margin-bottom:16px;padding:11px 15px;border-radius:11px;font-size:13px;font-weight:700;}",
  ".tp-global-msg.success{background:rgba(16,185,129,0.15);color:#86EFAC;border:1px solid rgba(16,185,129,0.3);}",
  ".tp-global-msg.error{background:rgba(239,68,68,0.15);color:#FCA5A5;border:1px solid rgba(239,68,68,0.3);}",

  /* table */
  ".tp-table-card{background:rgba(255,255,255,0.98);border:1px solid rgba(62,124,140,0.16);border-radius:16px;box-shadow:0 20px 48px rgba(62,124,140,0.12);padding:18px 20px;width:100%;box-sizing:border-box;overflow:hidden;}",
  ".tp-table-meta{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;}",
  ".tp-count{margin:0 0 14px;font-size:13px;color:#111827;font-weight:700;}",
  ".tp-table-wrap{width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;}",
  ".tp-table{width:100%;border-collapse:collapse;background:#ffffff;}",
  ".tp-table th{padding:10px 12px;text-align:left;vertical-align:middle;color:#2d5f6e;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;border-bottom:1px solid rgba(62,124,140,0.16);white-space:nowrap;background:#f8fafc;}",
  ".tp-table td{padding:13px 12px;vertical-align:middle;border-bottom:1px solid rgba(129,140,248,0.12);font-size:13px;color:#111827;}",
  ".tp-table tbody tr:hover{background:rgba(62,124,140,0.06);}",
  ".tp-table tbody tr:last-child td{border-bottom:none;}",
  ".tp-thumb{width:44px;height:44px;border-radius:9px;object-fit:cover;border:1px solid rgba(129,140,248,0.2);background:rgba(99,102,241,0.08);display:block;}",
  ".tp-thumb-ph{width:44px;height:44px;border-radius:9px;border:1px dashed rgba(62,124,140,0.22);background:rgba(62,124,140,0.08);display:flex;align-items:center;justify-content:center;color:#2d5f6e;font-size:18px;}",
  ".tp-badge{display:inline-flex;align-items:center;justify-content:center;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:700;}",
  ".tp-badge.active{background:rgba(52,211,153,0.08);color:#059669;}",
  ".tp-badge.inactive{background:rgba(248,113,113,0.10);color:#dc2626;}",
  ".tp-empty{padding:36px;text-align:center;color:#64748b;font-weight:700;font-size:14px;background:#f8fafc;border:1px dashed rgba(62,124,140,0.18);border-radius:14px;}",
  ".tp-loading{padding:36px;text-align:center;color:#2d5f6e;font-weight:700;font-size:14px;}",

  /* act-menu dot button */
  ".act-menu{position:relative;display:inline-flex;}",
  ".act-menu-btn{border:1px solid rgba(62,124,140,0.18);background:rgba(62,124,140,0.08);color:#2d5f6e;width:34px;height:34px;border-radius:10px;font-size:18px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;font-family:'Outfit',sans-serif;}",
  ".act-menu-btn:hover{background:rgba(242,140,40,0.18);box-shadow:0 8px 20px rgba(242,140,40,0.18);}",

  /* modal overlay (same as categories) */
  ".tp-modal-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(18,10,58,0.85);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;padding:20px;z-index:9999;}",

  /* edit modal box (same style as categories modal-box) */
  ".tp-edit-box{width:min(480px,100%);background:#20105E;border-radius:20px;padding:26px;box-shadow:0 22px 56px rgba(109,40,217,0.3);border:1px solid #312E81;max-height:calc(100vh - 96px);overflow-y:auto;box-sizing:border-box;}",
  ".tp-modal-hdr{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}",
  ".tp-modal-title{margin:0;font-size:17px;font-weight:800;color:#FFFFFF;}",
  ".tp-modal-close-btn{border:none;background:rgba(109,40,217,0.15);color:#A855F7;width:32px;height:32px;border-radius:9px;display:flex;align-items:center;justify-content:center;cursor:pointer;}",

  /* view modal box */
  ".tp-view-box{width:min(480px,100%);background:#20105E;border-radius:20px;padding:26px;box-shadow:0 22px 56px rgba(109,40,217,0.3);border:1px solid #312E81;max-height:calc(100vh - 96px);overflow-y:auto;box-sizing:border-box;}",
  ".tp-view-img-wrap{width:100%;height:180px;border-radius:12px;overflow:hidden;background:rgba(109,40,217,0.1);border:1px solid #312E81;display:flex;align-items:center;justify-content:center;margin-bottom:18px;}",
  ".tp-view-img{width:100%;height:100%;object-fit:contain;}",
  ".tp-view-img-ph{font-size:48px;}",
  ".tp-view-row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;border-bottom:1px solid rgba(49,46,129,0.5);}",
  ".tp-view-row:last-of-type{border-bottom:none;}",
  ".tp-view-label{color:#C4B5FD;font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;white-space:nowrap;}",
  ".tp-view-val{color:#FFFFFF;font-size:13px;font-weight:600;text-align:right;}",
  ".tp-view-footer{display:flex;justify-content:flex-end;margin-top:18px;}",
  ".tp-view-close-btn{border:none;background:rgba(109,40,217,0.15);color:#A855F7;padding:10px 22px;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;font-family:'Outfit',sans-serif;}",
].join('\n');


/* ── Custom Select (matches theme, portaled so it escapes clipped containers) ── */
var CustomSelect = function (props) {
  var value = props.value; var onChange = props.onChange; var options = props.options;
  var os = useState(false); var open = os[0]; var setOpen = os[1];
  var posState = useState({ top: 0, left: 0, width: 0 }); var pos = posState[0]; var setPos = posState[1];
  var triggerRef = React.useRef();
  var listRef = React.useRef();

  var openList = function () {
    if (triggerRef.current) {
      var rect = triggerRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
    }
    setOpen(true);
  };

  useEffect(function () {
    if (!open) return;
    var handler = function (ev) {
      if (triggerRef.current && triggerRef.current.contains(ev.target)) return;
      if (listRef.current && listRef.current.contains(ev.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    var reposition = function () {
      if (triggerRef.current) {
        var rect = triggerRef.current.getBoundingClientRect();
        setPos({ top: rect.bottom + 4, left: rect.left, width: rect.width });
      }
    };
    window.addEventListener('scroll', reposition, true);
    window.addEventListener('resize', reposition);
    return function () {
      document.removeEventListener('mousedown', handler);
      window.removeEventListener('scroll', reposition, true);
      window.removeEventListener('resize', reposition);
    };
  }, [open]);

  var selected = options.find(function (o) { return o.value === value; });

  return e('div', { style: { position: 'relative' } },
    e('button', {
      type: 'button',
      ref: triggerRef,
      className: 'tp-cs-trigger',
      onClick: function () { if (open) { setOpen(false); } else { openList(); } }
    },
      selected ? selected.label : 'Select',
      e('span', { style: { fontSize: 11, color: '#2d5f6e', marginLeft: 8 } }, '\u25BC')
    ),
    open && createPortal(
      e('div', {
        ref: listRef,
        className: 'cs-dropdown-list',
        style: {
          position: 'fixed', top: pos.top + 'px', left: pos.left + 'px', width: pos.width + 'px',
          background: '#ffffff', border: '1px solid rgba(62,124,140,0.22)',
          borderRadius: 11, zIndex: 999999,
          boxShadow: '0 16px 40px rgba(15,23,42,0.16)',
        }
      },
        options.map(function (o) {
          var isSel = o.value === value;
          return e('div', {
            key: o.value,
            onClick: function () { onChange(o.value); setOpen(false); },
            style: {
              padding: '10px 12px', fontSize: 13, cursor: 'pointer',
              color: isSel ? '#ffffff' : '#102a33',
              background: isSel ? '#3E7C8C' : '#ffffff',
              fontFamily: "'Outfit',sans-serif",
              transition: 'background 0.15s',
            },
            onMouseEnter: function (ev) { if (!isSel) ev.currentTarget.style.background = '#eef8fa'; },
            onMouseLeave: function (ev) { if (!isSel) ev.currentTarget.style.background = '#ffffff'; }
          }, o.label);
        })
      ),
      document.body
    )
  );
};


var TopPicks = function () {
  var picksState      = useState([]); var picks = picksState[0]; var setPicks = picksState[1];
  var productsState   = useState([]); var products = productsState[0]; var setProducts = productsState[1];
  var loadingState    = useState(false); var loading = loadingState[0]; var setLoading = loadingState[1];
  var showFormState   = useState(false); var showForm = showFormState[0]; var setShowForm = showFormState[1];
  var submittingState = useState(false); var submitting = submittingState[0]; var setSubmitting = submittingState[1];
  var deletingState   = useState(false); var deleting = deletingState[0]; var setDeleting = deletingState[1];
  var messageState    = useState({ text: '', type: '' }); var message = messageState[0]; var setMessage = messageState[1];
  var pendingDelState = useState(null); var pendingDel = pendingDelState[0]; var setPendingDel = pendingDelState[1];

  /* dropdown */
  var menuOpenState = useState(null); var openMenuId = menuOpenState[0]; var setOpenMenuId = menuOpenState[1];
  var menuPosState  = useState({ top: 0, right: 0 }); var menuPos = menuPosState[0]; var setMenuPos = menuPosState[1];

  /* view modal */
  var viewPickState = useState(null); var viewPick = viewPickState[0]; var setViewPick = viewPickState[1];
  var statusFilterState = useState('all'); var statusFilter = statusFilterState[0]; var setStatusFilter = statusFilterState[1];

  /* edit modal */
  var editPickState = useState(null); var editPick = editPickState[0]; var setEditPick = editPickState[1];
  var editFormState = useState({ order: '0', isActive: 'true' }); var editForm = editFormState[0]; var setEditForm = editFormState[1];
  var editMsgState  = useState({ text: '', type: '' }); var editMsg = editMsgState[0]; var setEditMsg = editMsgState[1];

  /* add form */
  var addFormState = useState({ productId: '', order: '0', isActive: 'true' }); var addForm = addFormState[0]; var setAddForm = addFormState[1];

  var emptyAddForm = { productId: '', order: '0', isActive: 'true' };

  var fetchPicks = useCallback(function () {
    setLoading(true);
    getAllTopPicks()
      .then(function (res) { setPicks((res.data && res.data.data) || []); })
      .catch(function (err) { setMessage({ text: (err.response && err.response.data && err.response.data.message) || 'Failed to load.', type: 'error' }); })
      .finally(function () { setLoading(false); });
  }, []);

  var fetchProducts = useCallback(function () {
    getAllProductsUnpaginated()
      .then(function (res) {
        var raw = res.data;
        var arr = Array.isArray(raw) ? raw : Array.isArray(raw && raw.data) ? raw.data : [];
        setProducts(arr.filter(function (p) { return !p.isDeleted && p.status === 'active'; }));
      })
      .catch(function () {});
  }, []);

  useEffect(function () { fetchPicks(); fetchProducts(); }, [fetchPicks, fetchProducts]);

  useEffect(function () {
    if (message.text) {
      var timer = setTimeout(function () {
        setMessage({ text: '', type: '' });
      }, 3500);
      return function () { clearTimeout(timer); };
    }
  }, [message]);

  useEffect(function () {
    if (editMsg.text) {
      var timer = setTimeout(function () {
        setEditMsg({ text: '', type: '' });
      }, 3500);
      return function () { clearTimeout(timer); };
    }
  }, [editMsg]);

  useEffect(function () {
    var handler = function (ev) {
      if (!ev || !ev.target || !ev.target.closest) { setOpenMenuId(null); return; }
      if (ev.target.closest('.act-menu-dd-portal') || ev.target.closest('.act-menu-btn')) return;
      setOpenMenuId(null);
    };
    document.addEventListener('mousedown', handler);
    return function () { document.removeEventListener('mousedown', handler); };
  }, []);

  var handleMenuOpen = function (ev, pickId) {
    var rect = ev.currentTarget.getBoundingClientRect();
    setMenuPos({ top: rect.bottom + 6, right: window.innerWidth - rect.right });
    setOpenMenuId(function (prev) { return prev === pickId ? null : pickId; });
  };

  /* ── Add form submit ── */
  var activePicks = picks.filter(isActiveStatus).length;
  var inactivePicks = picks.length - activePicks;
  var topPickStatCards = [
    { title: 'Total Top Picks', value: picks.length, description: 'Featured product slots', icon: 'star', accent: '#d99a2b', active: statusFilter === 'all', onClick: function () { setStatusFilter('all'); } },
    { title: 'Active Top Picks', value: activePicks, description: 'Shown on storefront', icon: 'check', accent: '#16a34a', active: statusFilter === 'active', onClick: function () { setStatusFilter('active'); } },
    { title: 'Inactive Top Picks', value: inactivePicks, description: 'Paused feature slots', icon: 'pause', accent: '#f59e0b', active: statusFilter === 'inactive', onClick: function () { setStatusFilter('inactive'); } },
    { title: 'Available Products', value: products.length, description: 'Eligible active products', icon: 'box', accent: '#0ea5e9', active: false },
  ];

  var filteredPicks = picks.filter(function (pick) {
    if (statusFilter === 'active') return isActiveStatus(pick);
    if (statusFilter === 'inactive') return !isActiveStatus(pick);
    return true;
  });

  var handleAddSubmit = function (ev) {
    ev.preventDefault();
    if (picks.length >= 10) { setMessage({ text: 'Maximum 10 top picks allowed.', type: 'error' }); return; }
    if (!addForm.productId) { setMessage({ text: 'Please select a product.', type: 'error' }); return; }
    setSubmitting(true); setMessage({ text: '', type: '' });
    addTopPick({ productId: addForm.productId, order: Number(addForm.order) || 0, isActive: addForm.isActive === 'true' })
      .then(function (res) {
        setMessage({ text: (res.data && res.data.message) || 'Added to top picks.', type: 'success' });
        setAddForm(emptyAddForm); setShowForm(false); fetchPicks();
      })
      .catch(function (err) { setMessage({ text: (err.response && err.response.data && err.response.data.message) || 'Something went wrong.', type: 'error' }); })
      .finally(function () { setSubmitting(false); });
  };

  

  /* ── Edit modal open ── */
  var openEditModal = function (pick) {
  var productId = (pick.product && (pick.product._id || pick.product.id || pick.product)) || '';
  setEditPick(pick);
  setEditForm({
    productId: String(productId),
    order: String(pick.order || 0),
    isActive: pick.isActive ? 'true' : 'false',
  });
  setEditMsg({ text: '', type: '' });
};

  /* ── Edit modal submit ── */
  var handleEditSubmit = function (ev) {
    ev.preventDefault();
    setSubmitting(true); setEditMsg({ text: '', type: '' });
    updateTopPick(editPick._id, { productId: editForm.productId, order: Number(editForm.order) || 0, isActive: editForm.isActive === 'true' })
      .then(function (res) {
        setEditMsg({ text: (res.data && res.data.message) || 'Updated successfully.', type: 'success' });
        fetchPicks();
        setTimeout(function () { setEditPick(null); }, 800);
      })
      .catch(function (err) { setEditMsg({ text: (err.response && err.response.data && err.response.data.message) || 'Something went wrong.', type: 'error' }); })
      .finally(function () { setSubmitting(false); });
  };

  /* ── Delete ── */
  var confirmDelete = function () {
    if (!pendingDel) return;
    setDeleting(true);
    deleteTopPick(pendingDel._id)
      .then(function (res) {
        setMessage({ text: 'Removed from Top Picks successfully.', type: 'success' });
        setPendingDel(null);
        fetchPicks();
      })
      .catch(function (err) {
        setMessage({ text: (err.response && err.response.data && err.response.data.message) || 'Failed to remove.', type: 'error' });
        setPendingDel(null);
      })
      .finally(function () { setDeleting(false); });
  };

  return e(AdminLayout, null,
    e('style', null, css),
    e('div', { className: 'tp-page' },

      /* ── Header ── */
      e('div', { className: 'tp-header-row' },
        e('div', { className: 'tp-header-main' },
          e('div', { className: 'tp-header-icon' },
            e('svg', { width: 20, height: 20, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' },
              e('polygon', { points: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' })
            )
          ),
          e('div', null,
            e('h1', { className: 'tp-heading' }, 'Top Picks'),
            e('p', { className: 'tp-subtitle' }, 'Manage the "Top picks this season" section on the homepage.'),
            e('p', { className: 'tp-subtitle', style: { marginTop: 4, color: picks.length >= 10 ? '#f87171' : '#86EFAC', fontWeight: 700 } },
              picks.length + ' / 10 top picks added' + (picks.length >= 10 ? ' — Limit reached' : '')
            )
          )
        ),
        e('button', {
          type: 'button', className: 'tp-new-btn',
          disabled: picks.length >= 10,
          title: picks.length >= 10 ? 'Maximum 10 top picks allowed' : '',
          style: picks.length >= 10 ? { opacity: 0.5, cursor: 'not-allowed' } : {},
          onClick: function () {
            if (picks.length >= 10) return;
            setAddForm(emptyAddForm); setMessage({ text: '', type: '' }); setShowForm(true);
          }
        }, '+ Add Top Pick')
      ),

      e(StatCards, { cards: topPickStatCards }),

      message.text && !showForm ? e('div', { className: 'tp-global-msg ' + message.type }, message.text) : null,

      /* ── Add Modal ── */
      showForm && e('div', {
        className: 'tp-modal-overlay',
        onClick: function (ev) { if (ev.target.classList.contains('tp-modal-overlay')) { setShowForm(false); setAddForm(emptyAddForm); } }
      },
        e('div', { className: 'tp-edit-box' },
          e('div', { className: 'tp-modal-hdr' },
            e('span', { className: 'tp-modal-title' }, 'Add New Top Pick'),
            e('button', { className: 'tp-modal-close-btn', type: 'button', onClick: function () { setShowForm(false); setAddForm(emptyAddForm); setMessage({ text: '', type: '' }); } }, e(XIcon, null))
          ),

          message.text && e('div', { style: { marginBottom: 14, padding: '10px 14px', borderRadius: 10, fontSize: 13, fontWeight: 700, background: message.type === 'success' ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)', color: message.type === 'success' ? '#86EFAC' : '#FCA5A5', border: '1px solid ' + (message.type === 'success' ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)') } }, message.text),

          e('form', { onSubmit: handleAddSubmit },
            e('div', { className: 'tp-group' },
              e('div', null,
                e('label', { className: 'tp-label' }, 'Select Product *'),
                e(CustomSelect, {
                  value: addForm.productId,
                  onChange: function (val) { setAddForm(function (p) { return Object.assign({}, p, { productId: val }); }); },
                  options: [{ value: '', label: '-- Select a product --' }].concat(
                    products.map(function (p) {
                      var id = String(p._id || p.id || '');
                      var price = p.salePrice || p.price || 0;
                      var label = p.name + (price ? ' \u2014 \u20B9' + Number(price).toLocaleString('en-IN') : '') + (p.category ? ' (' + (p.category.name || p.category) + ')' : '');
                      return { value: id, label: label };
                    })
                  )
                })
              ),
              e('div', { className: 'tp-field-row' },
                e('div', null,
                  e('label', { className: 'tp-label' }, 'Display Order'),
                  e('input', { className: 'tp-input', type: 'number', min: '0', value: addForm.order, onChange: function (ev) { setAddForm(function (p) { return Object.assign({}, p, { order: ev.target.value }); }); } })
                ),
                e('div', null,
                  e('label', { className: 'tp-label' }, 'Status'),
                  e(CustomSelect, {
                    value: addForm.isActive,
                    onChange: function (val) { setAddForm(function (p) { return Object.assign({}, p, { isActive: val }); }); },
                    options: [
                      { value: 'true', label: 'Active' },
                      { value: 'false', label: 'Inactive' }
                    ]
                  })
                )
              )
            ),
            e('div', { className: 'tp-submit-row', style: { marginTop: 20 } },
              e('button', { type: 'button', className: 'tp-reset', onClick: function () { setShowForm(false); setAddForm(emptyAddForm); setMessage({ text: '', type: '' }); } }, 'Cancel'),
              e('button', { type: 'submit', className: 'tp-submit', disabled: submitting }, submitting ? 'Adding\u2026' : 'Add to Top Picks')
            )
          )
        )
      ),

      /* ── Table ── */
      e('div', { className: 'tp-table-card' },
        e('div', { className: 'tp-table-meta' },
          e('p', { className: 'tp-count' }, statusFilter === 'all' ? 'All Top Picks (' + filteredPicks.length + ')' : (statusFilter.charAt(0).toUpperCase() + statusFilter.slice(1)) + ' Top Picks (' + filteredPicks.length + ')')
        ),
        loading
          ? e('div', { className: 'tp-loading' }, 'Loading\u2026')
          : filteredPicks.length === 0
            ? e('div', { className: 'tp-empty' }, statusFilter === 'all' ? React.createElement(React.Fragment, null, 'No top picks yet. Click ', e('strong', null, '+ Add Top Pick'), ' to add one.') : 'No ' + statusFilter + ' top picks found.')
            : e('div', { className: 'tp-table-wrap' },
                e('table', { className: 'tp-table' },
                  e('thead', null,
                    e('tr', null,
                      e('th', null, 'S.No'), e('th', null, 'Image'), e('th', null, 'Product Name'),
                      e('th', null, 'Price'), e('th', null, 'Order'), e('th', null, 'Status'), e('th', null, 'Actions')
                    )
                  ),
                  e('tbody', null,
                    filteredPicks.map(function (pick, index) {
                      var product = pick.product || {};
                      var imgUrl = getProductImage(product);
                      var price = product.salePrice || product.price || 0;
                      return e('tr', { key: pick._id },
                        e('td', null, index + 1),
                        e('td', null, imgUrl ? e('img', { src: imgUrl, alt: product.name || '', className: 'tp-thumb', onError: function (ev) { ev.target.style.display = 'none'; } }) : e('div', { className: 'tp-thumb-ph' }, '\uD83D\uDDBC')),
                        e('td', { style: { fontWeight: 600 } }, product.name || '—'),
                        e('td', null, price ? '\u20B9' + Number(price).toLocaleString('en-IN') : '—'),
                        e('td', null, pick.order || 0),
                        e('td', null, e('span', { className: 'tp-badge ' + (pick.isActive ? 'active' : 'inactive') }, pick.isActive ? 'Active' : 'Inactive')),
                        e('td', null,
                          e('div', { className: 'act-menu' },
                            e('button', { className: 'act-menu-btn', title: 'Actions', type: 'button', onClick: function (ev) { ev.stopPropagation(); handleMenuOpen(ev, pick._id); } }, '\u22EE')
                          )
                        )
                      );
                    })
                  )
                )
              )
      )
    ),

    /* ── View Modal ── */
    viewPick && e('div', {
      className: 'tp-modal-overlay',
      onClick: function (ev) { if (ev.target.classList.contains('tp-modal-overlay')) setViewPick(null); }
    },
      e('div', { className: 'tp-view-box' },
        e('div', { className: 'tp-modal-hdr' },
          e('span', { className: 'tp-modal-title' }, 'Top Pick Details'),
          e('button', { className: 'tp-modal-close-btn', onClick: function () { setViewPick(null); } }, e(XIcon, null))
        ),
        e('div', { className: 'tp-view-img-wrap' },
          (function () {
            var imgUrl = getProductImage(viewPick.product || {});
            return imgUrl
              ? e('img', { src: imgUrl, alt: '', className: 'tp-view-img', onError: function (ev) { ev.target.style.display = 'none'; } })
              : e('div', { className: 'tp-view-img-ph' }, '\uD83D\uDDBC');
          })()
        ),
        e('div', { className: 'tp-view-row' }, e('span', { className: 'tp-view-label' }, 'Product'), e('span', { className: 'tp-view-val' }, (viewPick.product && viewPick.product.name) || '—')),
        e('div', { className: 'tp-view-row' }, e('span', { className: 'tp-view-label' }, 'Price'), e('span', { className: 'tp-view-val' }, (function () { var price = (viewPick.product || {}).salePrice || (viewPick.product || {}).price || 0; return price ? '\u20B9' + Number(price).toLocaleString('en-IN') : '—'; })())),
        e('div', { className: 'tp-view-row' }, e('span', { className: 'tp-view-label' }, 'Display Order'), e('span', { className: 'tp-view-val' }, viewPick.order || 0)),
        e('div', { className: 'tp-view-row' }, e('span', { className: 'tp-view-label' }, 'Status'), e('span', { className: 'tp-badge ' + (viewPick.isActive ? 'active' : 'inactive') }, viewPick.isActive ? 'Active' : 'Inactive')),
        e('div', { className: 'tp-view-footer' },
          e('button', { className: 'tp-view-close-btn', onClick: function () { setViewPick(null); } }, 'Close')
        )
      )
    ),

    /* ── Edit Modal (same overlay style as Categories add/edit modal) ── */
    editPick && e('div', {
      className: 'tp-modal-overlay',
      onClick: function (ev) { if (ev.target.classList.contains('tp-modal-overlay')) setEditPick(null); }
    },
      e('div', { className: 'tp-edit-box' },
        e('div', { className: 'tp-modal-hdr' },
          e('span', { className: 'tp-modal-title' }, 'Edit Top Pick'),
          e('button', { className: 'tp-modal-close-btn', onClick: function () { setEditPick(null); } }, e(XIcon, null))
        ),

        editMsg.text && e('div', { style: { marginBottom: 14, padding: '10px 14px', borderRadius: 10, fontSize: 13, fontWeight: 700, background: editMsg.type === 'success' ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)', color: editMsg.type === 'success' ? '#86EFAC' : '#FCA5A5', border: '1px solid ' + (editMsg.type === 'success' ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)') } }, editMsg.text),

        e('form', { onSubmit: handleEditSubmit },
          e('div', { className: 'tp-group' },
            /* product name (read-only) */
            e('div', null,
              e('label', { className: 'tp-label' }, 'Select Product *'),
              e(CustomSelect, {
                value: editForm.productId,
                onChange: function (val) { setEditForm(function (p) { return Object.assign({}, p, { productId: val }); }); },
                options: [{ value: '', label: '-- Select a product --' }].concat(
                  products.map(function (p) {
                    var price = p.salePrice || p.price || 0;
                    var label = p.name + (price ? ' \u2014 \u20B9' + Number(price).toLocaleString('en-IN') : '') + (p.category ? ' (' + (p.category.name || p.category) + ')' : '');
                    return { value: String(p._id || p.id), label: label };
                  })
                )
              })
            ),
            e('div', { className: 'tp-field-row' },
              e('div', null,
                e('label', { className: 'tp-label' }, 'Display Order'),
                e('input', { className: 'tp-input', type: 'number', min: '0', value: editForm.order, onChange: function (ev) { setEditForm(function (p) { return Object.assign({}, p, { order: ev.target.value }); }); } })
              ),
              e('div', null,
                e('label', { className: 'tp-label' }, 'Status'),
                e(CustomSelect, {
                  value: editForm.isActive,
                  onChange: function (val) { setEditForm(function (p) { return Object.assign({}, p, { isActive: val }); }); },
                  options: [
                    { value: 'true', label: 'Active' },
                    { value: 'false', label: 'Inactive' }
                  ]
                })
              )
            )
          ),
          e('div', { className: 'tp-submit-row', style: { marginTop: 20 } },
            e('button', { type: 'button', className: 'tp-reset', onClick: function () { setEditPick(null); } }, 'Cancel'),
            e('button', { type: 'submit', className: 'tp-submit', disabled: submitting }, submitting ? 'Saving\u2026' : 'Save Changes')
          )
        )
      )
    ),

    /* ── Delete Confirm Modal ── */
    pendingDel && e(DeleteConfirmModal, {
      productName: (pendingDel.product && pendingDel.product.name) || 'this product',
      deleting: deleting,
      onConfirm: confirmDelete,
      onCancel: function () { if (!deleting) setPendingDel(null); }
    }),

    /* ── Portaled Dropdown ── */
    openMenuId && e(PortaledDropdown, {
      top: menuPos.top, right: menuPos.right,
      onClose: function () { setOpenMenuId(null); },
      onView: function () { var pick = picks.find(function (p) { return p._id === openMenuId; }); if (pick) setViewPick(pick); },
      onEdit: function () { var pick = picks.find(function (p) { return p._id === openMenuId; }); if (pick) openEditModal(pick); },
      onDelete: function () { var pick = picks.find(function (p) { return p._id === openMenuId; }); if (pick) setPendingDel(pick); },
    })
  );
};

export default TopPicks;



